import React from "react";

/**
 * Corporate ownership marker: "Powered by TendStrat Solutions".
 * Preserves the TendStrat logo's original colours; sits at ~25–35% visual
 * weight of primary TWIN branding per the brand guidelines.
 *
 * Variants:
 *   - "dark":  used on dark hero / dark surfaces. The logo is wrapped in
 *              a subtle white card so its original colours read cleanly.
 *   - "light": used on white / light surfaces (footer, login form panel).
 */
export default function PoweredByTendStrat({ variant = "light", className = "", size = "md" }) {
  const isDark = variant === "dark";
  const isSm = size === "sm";
  const label = isDark ? "text-white/70" : "text-ink-muted";
  const brand = isDark ? "text-white" : "text-ink";

  const logoHeight = isSm ? "h-5" : "h-7";
  const logoWrapper = isDark
    ? "bg-white/95 rounded-sm px-2 py-1 shadow-sm"
    : "";

  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="powered-by-tendstrat"
    >
      <span className={`text-[11px] uppercase tracking-[0.2em] font-num ${label}`}>
        Powered by
      </span>
      <span className={logoWrapper}>
        <img
          src="/brand/tendstrat-logo.jpeg"
          alt="TendStrat Solutions"
          className={`${logoHeight} w-auto object-contain block`}
          draggable="false"
        />
      </span>
      <span className={`sr-only ${brand}`}>TendStrat Solutions</span>
    </div>
  );
}
